import React from "react";
import { useBlurAnimation } from "../../../../shared/animation";
import * as S from "./styles";
export var DesktopMenuItem = function DesktopMenuItem(_ref) {
  var e = _ref.active,
      t = _ref.label,
      n = _ref.menuSlug,
      a = _ref.onClickHandler,
      l = _ref.handleClose,
      r = _ref.children;
  var o = useBlurAnimation(e);
  return React.createElement(React.Fragment, null, React.createElement(S.MenuButton, {
    active: e,
    onClick: a,
    "data-testid": "desktop-menu-button-".concat(n)
  }, t), React.createElement(S.Drawer, null, r), o(function (e, t) {
    return t ? React.createElement(S.Backdrop, {
      onClick: l,
      style: e
    }) : null;
  }));
};
export default DesktopMenuItem;